import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-pause\"><path d=\"M13.5 8a1 1 0 0 1 1 1v14a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1m5 0a1 1 0 0 1 1 1v14a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol